module.exports = prestashop;


//////////////////
// WEBPACK FOOTER
// external "prestashop"
// module id = 2
// module chunks = 0